<!-- message-detail-bottom-sheet.component.html -->
<div class="message-detail-container mb-5">
  <!-- Header -->
  <div class="message-header d-flex justify-content-between align-items-center mb-3">
    <h4 class="m-0">Dettaglio Notifica</h4>
    <button mat-icon-button (click)="closeBottomSheet()" aria-label="Chiudi">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Message Type Chip -->
  <div class="mb-3">
    <mat-chip 
      [color]="getMessageTypeColor(data.message.type)" 
      variant="outlined"
      class="type-chip">
      <mat-icon matChipAvatar>{{ getMessageTypeIcon(data.message.type) }}</mat-icon>
      {{ getMessageTypeLabel(data.message.type) }}
    </mat-chip>
  </div>

  <!-- Message Title -->
  <h2 class="message-title mb-3">
    {{ data.message.title || 'Nessun titolo' }}
  </h2>

  <!-- Sender and Date -->
  <div class="message-meta mb-4">
    <p class="m-0 text-muted">
      <strong>Da:</strong> {{ data.message.sender || 'Sconosciuto' }}
    </p>
    <p class="m-0 text-muted">
      <strong>Data:</strong> {{ formatDate(data.message.date) }}
    </p>
  </div>

  <mat-divider class="mb-4"></mat-divider>

  <!-- Message Content -->
  <div class="message-content mb-4">
    <h5 class="mb-3">Contenuto</h5>
    <div class="message-text">
      {{ data.message.message || 'Nessun contenuto' }}
    </div>
  </div>

  <!-- Attachment Section -->
  <div *ngIf="hasAttachment(data.message)" class="attachment-section">
    <mat-divider class="mb-3"></mat-divider>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h5 class="mb-1">Allegato</h5>
        <p class="text-muted m-0">Clicca per visualizzare il file</p>
      </div>
      <button 
        mat-raised-button 
        color="primary" 
        (click)="downloadAttachment()"
        class="attachment-button">
        <mat-icon>attach_file</mat-icon>
        Apri Allegato
      </button>
    </div>
  </div>
</div>
